export default "__VITE_ASSET__BapLB01a__"